import { createSelector } from 'reselect';
import { getProjectLazy } from 'src/modules/common/selectors/getProjectLazy';

export const getHvacCurrencyCode = createSelector([
  getProjectLazy,
], (project) => project.data.currency);
